import { formatDate } from '@tracsis/library/lib/helpers';
import cx from 'classnames';
import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import { Content, NewsBanner, Section, Table, YouTubeEmbed } from '../../index';
import { LinkedIn, X } from '../Icon';
import * as styles from './Post.module.css';

const Post = ({
	title,
	date,
	url,
	snippet,
	content,
	canonicalSite,
}: {
	title: string;
	date: string;
	url: string;
	snippet: React.ReactNode;
	content: any;
	canonicalSite: { label: string; tag: string; to: string; uuid: string };
}) => {
	// Lots of the legacy data imported into Storyblok is a single string with all the HTML
	const isString = typeof content === 'string';

	return (
		<article className="post">
			<Section>
				<Content>
					{snippet}
					<h1>{title}</h1>
					<p>{formatDate(date)}</p>
				</Content>

				{canonicalSite && (
					<Content clamp>
						<NewsBanner canonicalSite={canonicalSite} />
					</Content>
				)}

				<Content clamp>
					<div className={cx('rhythm')}>
						{isString ? (
							<div dangerouslySetInnerHTML={{ __html: content }} />
						) : (
							render(content, {
								blokResolvers: {
									['table']: (props) => <Table {...props} />,
									['youtube_embed']: (props) => <YouTubeEmbed {...props} />,
								},
							})
						)}
					</div>
				</Content>
				<div className={styles.share}>
					<span>Share via:</span>
					<ul className={styles.shareList}>
						<li>
							<a
								href={`https://x.com/share?text=${title}&url=${url}`}
								className={styles.shareLink}
							>
								<X />
							</a>
						</li>
						<li>
							<a
								href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}&title=${title}`}
								className={styles.shareLink}
							>
								<LinkedIn />
							</a>
						</li>
					</ul>
				</div>
			</Section>
		</article>
	);
};

export default Post;
